import { Button } from '@nazka/nazka.mapframe.components';

import './admin-actions.styl';

function AdminActions({ actions }) {
  return (
    <div className="admin-actions">
      {actions.map((action) => {
        return (
          <Button
            className="admin-actions__button"
            disabled={action.disabled ?? false}
            key={action.id}
            onClick={() => {
              if (action.onClick) {
                action.onClick();
              }
            }}
            icon={action.icon ?? undefined}
            isLoading={action.isLoading ?? false}
          >
            {action.text}
          </Button>
        )
      })}
    </div>
  );
}

export default AdminActions;